// extracted by mini-css-extract-plugin
export default {"details":"Qp3NCBsVrzX73ioNWtmM","timestamp":"HMgjXZOXsUG0eDnODE1U","seek":"QcajBXtaB01rX8fR5aOb","speaker":"kOJgckJA3JBvl9oKEY3K","text":"tvFlBBoGa1XNvDMrpWcF"};